import { AppRouteProps } from "@harea/component";
import ProjectTimeOffCreateLeavingContainer from "../leaving/container/ProjectTimeOffCreateLeavingContainer";

export const ProjectAppointmentCreateVacationRoutes: Array<AppRouteProps> = [
  {
    path: "",
    title: "BSMRH.Project.Appointment.Create.Label",
    element: <ProjectTimeOffCreateLeavingContainer />,
  },
];